export default {
    // The key format should be: 'locale.filename'.
    'de.revisions': require('../../lang/de/revisions.php'),
    'en.revisions': require('../../lang/en/revisions.php'),
    'de.auth': require('../../lang/de/auth.php'),
    'en.auth': require('../../lang/en/auth.php'),
    'de.main': require('../../lang/de/main.php'),
    'en.main': require('../../lang/en/main.php'),
    'de.duplicates': require('../../lang/de/duplicates.php'),
    'en.duplicates': require('../../lang/en/duplicates.php'),
    'de.map': require('../../lang/de/map.php'),
    'en.map': require('../../lang/en/map.php'),
    'de.rating': require('../../lang/de/rating.php'),
    'en.rating': require('../../lang/en/rating.php'),
}